import { CONTRIBUTION_TYPE } from '../../../_core/constants/Contribute';
import { PaymentStatus } from '../../../_core/constants/Payment';
import { RECURRENCE_PATTERN } from '../../../_shared/recurring-form/recurring-form.models';

export interface RecurringContributionsResponse {
  totalItems: number;
  data: RecurringContributionItem[];
  totalPages: number;
  currentPage: number;
}

export interface RecurringContributionItem {
  uuid: string;
  subscriptionId: string;
  entityName: string;
  contributionType: CONTRIBUTION_TYPE;
  amount: number;
  recurrencePattern: RECURRENCE_PATTERN;
  startDate: number;
  endDate: number;
  createdDate: number;
  status: PaymentStatus;
  currency: string;
}

export enum HEADERS {
  ID = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_ID',
  CHARITY = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_CHARITY',
  CONTRIBUTION_TYPE = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_CONTRIBUTION_TYPE',
  AMOUNT = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_AMOUNT',
  RECURRENCE_PATTERN = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_RECURRENCE_PATTERN',
  START_DATE = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_START_DATE',
  END_DATE = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_END_DATE',
  CREATED_DATE = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_CREATED_DATE',
  STATUS = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_STATUS',
  ACTIONS = 'DONATE_MANAGE_RECURRING_CONTRIBUTION_ACTIONS',
}
